/* PLTE Maison - sokjes als momenten (C5); spec: ULTRA/integration/motion.md */
(function () {
  'use strict';
  var P = window.PLTE = window.PLTE || {}, S = P.settings || {};
  var reduce = matchMedia('(prefers-reduced-motion: reduce)').matches, fine = matchMedia('(pointer: fine)').matches;
  var NS = 'http://www.w3.org/2000/svg', MAX = 24, PI = Math.PI, live = 0, lastAt = 0, layer;
  var T = [0, .08, .15, .35, .55, .78, 1], OP = [0, 1, 1, 1, 1, .6, 0], SC = [.4, .8, 1, 1, 1, .92, .85];
  function rnd(a, b) { return a + Math.random() * (b - a); }
  function colours(el) {
    el = el && el.closest ? el : document.body;
    if (el.closest('.media:not(.media--placeholder)')) return ['var(--bone)', 'var(--sand)', ' sock-fx--media'];
    var s = el.closest('[data-surface]'); s = s ? s.getAttribute('data-surface') : 'beige';
    return s === 'bordeaux' ? ['var(--bone)', 'var(--sand)'] : s === 'night' || s === 'chocolate' ? ['var(--sand)', 'var(--bone)'] : ['var(--bordeaux)', 'var(--sand)'];
  }
  function gone(n) { if (n && !n._gone) { n._gone = 1; n.remove(); live--; } }
  function burst(x, y, o) {
    o = o || {};
    if (reduce || S.socks === false || document.hidden || document.documentElement.hasAttribute('data-motion-off')) return 0;
    layer = layer || document.getElementById('socks-layer');
    if (!layer || !layer.animate || Date.now() - lastAt < 400) return 0;
    lastAt = Date.now();
    var n = Math.min(fine ? 9 : 5, o.count || 6, S.socksCount || 9), mode = o.mode || 'cone';
    var c = colours(o.surfaceEl);
    for (var i = 0; i < n; i++) {
      while (live >= MAX && layer.firstChild) { var f = layer.firstChild; gone(f); if (f._a) f._a.cancel(); }
      var a = mode === 'ring' ? i / n * 2 * PI + rnd(-.3, .3) : -PI / 2 + (mode === 'spread' ? rnd(-.35, .35) : rnd(-.96, .96));
      var sx = mode === 'spread' ? (i / (n - 1 || 1) + .125) * .8 * innerWidth : x;
      var v = rnd(120, 200), vx = Math.cos(a) * v, vy = Math.sin(a) * v, g = mode === 'ring' ? rnd(30, 70) : rnd(110, 200);
      var D = rnd(1.3, 1.8), k = rnd(.6, 1.1), A = rnd(5, 14), w = rnd(4.5, 7), ph = rnd(0, 2 * PI), rot = (Math.random() < .5 ? -1 : 1) * rnd(40, 90), size = rnd(10, 18);
      var frames = T.map(function (q, j) {
        var t = q * D, px = vx * (1 - Math.exp(-k * t)) / k + A * (Math.sin(w * t + ph) - Math.sin(ph)), py = vy * t + .5 * g * t * t;
        return { transform: 'translate(-50%,-50%) translate(' + px + 'px,' + py + 'px) rotate(' + rot * q + 'deg) scale(' + SC[j] + ')', opacity: OP[j], offset: q };
      });
      var svg = document.createElementNS(NS, 'svg'), use = document.createElementNS(NS, 'use');
      svg.setAttribute('viewBox', '0 0 64 60'); svg.setAttribute('class', 'sock-fx' + (c[2] || '')); use.setAttribute('href', '#plte-sock'); svg.appendChild(use);
      svg.style.cssText = 'left:' + sx + 'px;top:' + y + 'px;width:' + size + 'px;height:' + size * .9375 + 'px;color:' + c[0] + ';--sock-cuff:' + c[1];
      layer.appendChild(svg); live++;
      svg._a = svg.animate(frames, { duration: D * 1000, delay: rnd(0, 60), easing: 'linear', fill: 'forwards' });
      svg._a.onfinish = svg._a.oncancel = gone.bind(null, svg);
    }
    return n;
  }
  function at(el, o) { if (!el) return 0; var r = el.getBoundingClientRect(); o = o || {}; o.surfaceEl = o.surfaceEl || el; return burst(r.left + r.width / 2, r.top + r.height / 2, o); }
  function success(el) { return at(el, { count: 5 }); }
  document.addEventListener('click', function (e) {
    var h = e.target.closest('[data-socks-hotspot]');
    if (h) return e.clientX || e.clientY ? burst(e.clientX, e.clientY, { count: 9, mode: 'spread', surfaceEl: h }) : at(h, { count: 9, mode: 'spread' });
    var b = S.socksScope === 'buttons' && e.target.closest('.btn');
    if (b && !b.disabled && !b.matches('[data-add],[data-buy-btn],[data-quiz-add],[data-sticky-buy],[data-checkout]')) at(b, { count: 3 });
  });
  var ok = document.querySelector('[data-form-success]'), lf = document.querySelector('.list-form__ok'), fm = lf && lf.closest('form');
  success(ok || (fm && fm.id && location.hash === '#' + fm.id ? lf : null));
  P.socks = { burst: burst, at: at, success: success };
})();
